var _path, _path2, _g, _path3, _g2, _path4, _g3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImageIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_491_6651)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_491_6651)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.3641 37.8096H14.4083C13.2916 37.8096 12.3862 36.9045 12.3862 35.7875V11.5239C12.3862 10.4072 13.2916 9.50195 14.4083 9.50195H28.0112L37.3862 18.8766V35.7875C37.3862 36.9045 36.4808 37.8096 35.3641 37.8096Z",
    fill: "url(#paint0_linear_491_6651)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.51,
    filter: "url(#filter1_f_491_6651)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "darken"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1581 23.1963H16.7979V30.9166H33.1581V23.1963Z",
    fill: "#E33CC8"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.12
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.6473 20.99C19.2412 20.99 18.912 21.3192 18.912 21.7253V32.019C18.912 32.4252 19.2412 32.7543 19.6473 32.7543H29.9414C30.3475 32.7543 30.6767 32.4252 30.6767 32.019V21.7253C30.6767 21.3192 30.3475 20.99 29.9414 20.99H19.6473ZM17.4414 21.7253C17.4414 20.5071 18.429 19.5195 19.6473 19.5195H29.9414C31.1597 19.5195 32.1472 20.5071 32.1472 21.7253V32.019C32.1472 33.2374 31.1597 34.2249 29.9414 34.2249H19.6473C18.429 34.2249 17.4414 33.2374 17.4414 32.019V21.7253Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.2157 24.8814C27.5029 24.5942 27.9684 24.5942 28.2555 24.8814L31.932 28.5577C32.2191 28.8448 32.2191 29.3104 31.932 29.5975C31.6449 29.8846 31.1793 29.8846 30.8922 29.5975L27.7356 26.4411L20.1673 34.0091C19.8802 34.2963 19.4146 34.2963 19.1275 34.0091C18.8403 33.7219 18.8403 33.2565 19.1275 32.9694L27.2157 24.8814Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.2208 23.9314C22.0178 23.9314 21.8531 24.0961 21.8531 24.2991C21.8531 24.5021 22.0178 24.6667 22.2208 24.6667C22.4238 24.6667 22.5884 24.5021 22.5884 24.2991C22.5884 24.0961 22.4238 23.9314 22.2208 23.9314ZM20.3826 24.2991C20.3826 23.2839 21.2055 22.4609 22.2208 22.4609C23.236 22.4609 24.059 23.2839 24.059 24.2991C24.059 25.3143 23.236 26.1373 22.2208 26.1373C21.2055 26.1373 20.3826 25.3143 20.3826 24.2991Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_491_6651",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 9,
    width: 26,
    height: 29
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3641 37.8096H14.4083C13.2916 37.8096 12.3862 36.9045 12.3862 35.7875V11.5239C12.3862 10.4072 13.2916 9.50195 14.4083 9.50195H28.0112L37.3862 18.8766V35.7875C37.3862 36.9045 36.4808 37.8096 35.3641 37.8096Z",
    fill: "url(#paint1_linear_491_6651)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_491_6651)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M11.0535 27.3319C22.3987 27.3319 31.5958 18.5055 31.5958 7.61761C31.5958 -3.27029 22.3987 -12.0967 11.0535 -12.0967C-0.291678 -12.0967 -9.48877 -3.27029 -9.48877 7.61761C-9.48877 18.5055 -0.291678 27.3319 11.0535 27.3319Z",
    fill: "url(#paint2_linear_491_6651)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M11.0535 19.9791C18.1855 19.9791 23.9671 14.4446 23.9671 7.61749C23.9671 0.790351 18.1855 -4.74414 11.0535 -4.74414C3.9215 -4.74414 -1.86011 0.790351 -1.86011 7.61749C-1.86011 14.4446 3.9215 19.9791 11.0535 19.9791Z",
    fill: "url(#paint3_linear_491_6651)"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3455 24.2561H20.3198V27.5068C20.3198 27.8073 20.2522 28.0683 20.1172 28.2898C19.9836 28.5114 19.7977 28.6821 19.5594 28.802C19.3212 28.9219 19.0442 28.9819 18.7286 28.9819C18.4478 28.9819 18.1929 28.9325 17.9637 28.8339C17.7361 28.7337 17.5555 28.582 17.4219 28.3786C17.2884 28.1738 17.2224 27.9165 17.2239 27.6069H18.205C18.208 27.7298 18.2331 27.8353 18.2801 27.9233C18.3287 28.0099 18.3947 28.0766 18.4782 28.1237C18.5632 28.1692 18.6633 28.192 18.7786 28.192C18.9001 28.192 19.0025 28.1662 19.086 28.1146C19.171 28.0615 19.2354 27.9841 19.2794 27.8824C19.3235 27.7807 19.3455 27.6555 19.3455 27.5068V24.2561ZM21.5834 28.9181V24.2561H23.4227C23.7763 24.2561 24.0776 24.3237 24.3264 24.4587C24.5753 24.5923 24.765 24.7782 24.8955 25.0164C25.0276 25.2532 25.0936 25.5263 25.0936 25.8359C25.0936 26.1455 25.0268 26.4187 24.8933 26.6554C24.7597 26.8922 24.5662 27.0765 24.3128 27.2086C24.0609 27.3406 23.7558 27.4066 23.3977 27.4066H22.2253V26.6167H23.2383C23.428 26.6167 23.5844 26.5841 23.7073 26.5188C23.8317 26.4521 23.9243 26.3602 23.985 26.2434C24.0472 26.125 24.0783 25.9892 24.0783 25.8359C24.0783 25.6811 24.0472 25.5461 23.985 25.4307C23.9243 25.3139 23.8317 25.2236 23.7073 25.1599C23.5828 25.0946 23.425 25.062 23.2338 25.062H22.5691V28.9181H21.5834ZM29.2738 25.7631C29.2419 25.6523 29.1972 25.5544 29.1395 25.4694C29.0819 25.3829 29.0113 25.3101 28.9278 25.2509C28.8459 25.1902 28.7518 25.1439 28.6456 25.112C28.5408 25.0802 28.4247 25.0642 28.2973 25.0642C28.059 25.0642 27.8496 25.1234 27.669 25.2418C27.4899 25.3602 27.3503 25.5324 27.2502 25.7585C27.15 25.9831 27.0999 26.2578 27.0999 26.5826C27.0999 26.9073 27.1492 27.1835 27.2479 27.4112C27.3465 27.6388 27.4861 27.8126 27.6667 27.9324C27.8473 28.0508 28.0605 28.11 28.3064 28.11C28.5294 28.11 28.7199 28.0706 28.8777 27.9916C29.0371 27.9112 29.1585 27.7982 29.2419 27.6524C29.3269 27.5068 29.3694 27.3345 29.3694 27.1357L29.5698 27.1653H28.3678V26.4232H30.3187V27.0105C30.3187 27.4203 30.2322 27.7723 30.0592 28.0668C29.8862 28.3597 29.6479 28.5858 29.3444 28.7451C29.0409 28.903 28.6934 28.9819 28.3018 28.9819C27.8648 28.9819 27.4808 28.8855 27.15 28.6928C26.8192 28.4985 26.5611 28.2231 26.376 27.8665C26.1924 27.5083 26.1006 27.0834 26.1006 26.5917C26.1006 26.2138 26.1552 25.8769 26.2645 25.581C26.3752 25.2835 26.5301 25.0316 26.7288 24.8252C26.9277 24.6188 27.1591 24.4617 27.4231 24.354C27.6872 24.2463 27.9733 24.1924 28.2813 24.1924C28.5454 24.1924 28.7912 24.2311 29.0189 24.3085C29.2465 24.3843 29.4484 24.4921 29.6244 24.6317C29.8019 24.7713 29.9469 24.9375 30.0592 25.1302C30.1715 25.3215 30.2436 25.5324 30.2754 25.7631H29.2738Z",
    fill: "white"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_491_6651)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.3862 18.8766H35.0625C31.1682 18.8766 28.0112 15.7196 28.0112 11.8253V9.50195L37.3862 18.8766Z",
    fill: "url(#paint4_linear_491_6651)"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_491_6651",
    x: 8.38623,
    y: 9.50195,
    width: 33,
    height: 36.3076,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_491_6651"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_491_6651",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_491_6651",
    x: -22.2021,
    y: -15.8037,
    width: 94.3604,
    height: 85.7207,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 19.5,
    result: "effect1_foregroundBlur_491_6651"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_491_6651",
    x: 5.01123,
    y: -14.498,
    width: 59.375,
    height: 59.375,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.33 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_491_6651"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_491_6651",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_491_6651",
    x1: 24.8862,
    y1: 9.50195,
    x2: 24.8862,
    y2: 37.8096,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED81FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC5DD7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_491_6651",
    x1: 24.8862,
    y1: 9.50195,
    x2: 24.8862,
    y2: 37.8096,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED81FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC5DD7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_491_6651",
    x1: 12.545,
    y1: 8.29508,
    x2: 18.7743,
    y2: 24.8283,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_491_6651",
    x1: 11.9911,
    y1: 8.0423,
    x2: 15.8897,
    y2: 18.4158,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_491_6651",
    x1: 30.0792,
    y1: 6.5609,
    x2: 32.6984,
    y2: 18.8766,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F171BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D823D1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_491_6651"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageIcon);
export default __webpack_public_path__ + "static/media/image-icon.45f215251ea0d23463b2c8ad15c59038.svg";
export { ForwardRef as ReactComponent };